module.exports = __webpack_public_path__ + "img/1.d374b7a3.png";